/**************************************************
 * Nombre:       Seccion_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Marcas from "./Apartados/Home_Marcas";
import Home_Contactos from "./Apartados/Home_Contactos";
import Testimonios from "./Componentes/Testimonios";
import Detalle_Producto from "./Apartados/Detalle_Producto";
import Detalle_Condiciones from "./Apartados/Detalle_Condiciones";
import Detalle_Relacionados from "./Apartados/Detalle_Relacionados";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Seccion_Detalle = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Detalle_Producto/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? -6 : 6}}>
                <Detalle_Condiciones/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Detalle_Relacionados/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Home_Marcas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Contactos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Testimonios/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Detalle